const ALPHABET = "0123456789abcdefghjkmnpqrstvwxyz";

/** URL-safe random id, e.g. `chat_8fk2m9x0q4tzvb1c`. Works in Workers, Bun and browsers. */
export function newId(prefix: IdPrefix): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  let out = "";
  for (const b of bytes) out += ALPHABET[b % 32];
  return `${prefix}_${out}`;
}

export const ID_PREFIXES = [
  "usr",
  "org",
  "team",
  "auto",
  "arun",
  "lic",
  "inv",
  "repo",
  "wkr",
  "wcl",
  "wt",
  "chat",
  "job",
  "turn",
  "snap",
  "req",
  "term",
  "prod",
  "att",
  "aud",
  "int",
  "bind",
  "inbox",
  "outbox",
  /** api_token */
  "tok",
  /** assistant_session */
  "asn",
  /** Reserved for an assistant conversation identifier. The row itself is
   * keyed by its chat id, because an assistant conversation *is* a chat. */
  "acv",
  /** assistant_wake */
  "wake",
  /** Reserved for a channel installation identifier. A Slack/Teams install is
   * stored as an `integration_connection` row and uses the `int` prefix. */
  "chi",
  /** channel_conversation. `channel_outbox` rows reuse `outbox`. */
  "chc",
  /** task_approval */
  "apr",
  /** team_message */
  "tm",
  /** notification (inbox entry) */
  "ntf",
] as const;

export type IdPrefix = (typeof ID_PREFIXES)[number];
